import { render, staticRenderFns } from "./FormSelection.vue?vue&type=template&id=12333364"
import script from "./FormSelection.vue?vue&type=script&lang=js"
export * from "./FormSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports